import { colaboratorsURL } from '.';
import { AxiosInstance } from 'axios';
import { createAuthenticatedApi } from './axios-client';

export type Colaborator = {
  id: string;
  name: string;
  email: string;
  phone: string;
  isDeleted: boolean;
  invited: boolean;
};

// `invited` is managed server-side (via the invite endpoint), so it is
// optional when creating/updating a colaborator from the form.
export type ColaboratorWriteModel = Omit<Colaborator, 'id' | 'invited'> & {
  invited?: boolean;
};

function getColaboratorApi(): AxiosInstance {
  return createAuthenticatedApi(colaboratorsURL);
}

export async function createColaborator(
  colaborator: ColaboratorWriteModel,
): Promise<Colaborator> {
  const api = getColaboratorApi();

  const res = await api.post('', colaborator);

  return res.data as Colaborator;
}
export async function updateColaborator(
  id: string,
  colaborator: ColaboratorWriteModel,
): Promise<Colaborator> {
  const api = getColaboratorApi();

  const res = await api.put(`/${id}`, colaborator);

  return res.data as Colaborator;
}

export async function inviteColaborator(id: string): Promise<Colaborator> {
  const api = getColaboratorApi();

  const res = await api.post(`/${id}/invite`);

  return res.data as Colaborator;
}
export async function getAllColaborators(): Promise<Colaborator[]> {
  const api = getColaboratorApi();

  const res = await api.get('');

  return res.data as Colaborator[];
}

export async function getColaboratorByID(id: string): Promise<Colaborator> {
  const api = getColaboratorApi();

  const res = await api.get(`/${id}`);

  return res.data as Colaborator;
}

export async function deleteColaborator(id: string): Promise<void> {
  const api = getColaboratorApi();

  await api.delete(`/${id}`);
}
